/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CreatePupilFeedbackFeedbackInput,
  GetPupilFeedbackAssignmentParams,
  ListPupilFeedbackResponsesParams,
  PupilFeedbackAssignment,
  PupilFeedbackAssignmentRequestInput,
  PupilFeedbackFeedback,
  PupilFeedbackResponse,
  PupilFeedbackResponseRequestInput,
  PupilFeedbackResponses,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create a Pupil Feedback Response
 */
export const createPupilFeedbackResponse = (
    assignmentId: MaybeRefOrGetter<string>,
    pupilFeedbackResponseRequestInput: MaybeRefOrGetter<PupilFeedbackResponseRequestInput>,
 signal?: AbortSignal
) => {
      assignmentId = toValue(assignmentId);
pupilFeedbackResponseRequestInput = toValue(pupilFeedbackResponseRequestInput);

      return axiosClient<PupilFeedbackResponse>(
      {url: `/pupil_feedback/assignments/${assignmentId}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pupilFeedbackResponseRequestInput, signal
    },
      );
    }




export const getCreatePupilFeedbackResponseMutationKey = () => ['createPupilFeedbackResponse'] as const;

export const getCreatePupilFeedbackResponseMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackResponse>>, TError,CreatePupilFeedbackResponseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackResponse>>, TError,CreatePupilFeedbackResponseMutationVariables, TContext> => {

const mutationKey = getCreatePupilFeedbackResponseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPupilFeedbackResponse>>, CreatePupilFeedbackResponseMutationVariables> = (props) => {
          const {assignmentId,data} = props ?? {};

          return  createPupilFeedbackResponse(assignmentId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePupilFeedbackResponseMutationResult = NonNullable<Awaited<ReturnType<typeof createPupilFeedbackResponse>>>
    export type CreatePupilFeedbackResponseMutationBody = PupilFeedbackResponseRequestInput
    export type CreatePupilFeedbackResponseMutationError = ErrorType<SchemaValidationErrorResponse>
    export type CreatePupilFeedbackResponseMutationVariables = {assignmentId: string;data: PupilFeedbackResponseRequestInput}

    /**
 * @summary Create a Pupil Feedback Response
 */
export const useCreatePupilFeedbackResponse = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackResponse>>, TError,CreatePupilFeedbackResponseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPupilFeedbackResponse>>,
        TError,
        CreatePupilFeedbackResponseMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePupilFeedbackResponseMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Pupil Feedback Responses
 */
export const listPupilFeedbackResponses = (
    assignmentId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilFeedbackResponsesParams>,
 signal?: AbortSignal
) => {
      assignmentId = toValue(assignmentId);
params = toValue(params);

      return axiosClient<PupilFeedbackResponses>(
      {url: `/pupil_feedback/assignments/${assignmentId}/responses`, method: 'GET',
        params, signal
    },
      );
    }




export const getListPupilFeedbackResponsesQueryKey = (assignmentId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilFeedbackResponsesParams>,) => {
    return [
    'pupil_feedback','assignments',assignmentId,'responses', ...(params ? [params] : [])
    ] as const;
    }


export const getListPupilFeedbackResponsesQueryOptions = <TData = Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(assignmentId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilFeedbackResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPupilFeedbackResponsesQueryKey(assignmentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPupilFeedbackResponses>>> = ({ signal }) => listPupilFeedbackResponses(assignmentId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(assignmentId) !== null && toValue(assignmentId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError, TData>
}

export type ListPupilFeedbackResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof listPupilFeedbackResponses>>>
export type ListPupilFeedbackResponsesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Pupil Feedback Responses
 */

export function useListPupilFeedbackResponses<TData = Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 assignmentId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilFeedbackResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPupilFeedbackResponsesQueryOptions(assignmentId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Assignment Details
 */
export const getPupilFeedbackAssignment = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetPupilFeedbackAssignmentParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<PupilFeedbackAssignment>(
      {url: `/pupil_feedback/assignments/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetPupilFeedbackAssignmentQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetPupilFeedbackAssignmentParams>,) => {
    return [
    'pupil_feedback','assignments',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPupilFeedbackAssignmentQueryOptions = <TData = Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetPupilFeedbackAssignmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPupilFeedbackAssignmentQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>> = ({ signal }) => getPupilFeedbackAssignment(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError, TData>
}

export type GetPupilFeedbackAssignmentQueryResult = NonNullable<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>>
export type GetPupilFeedbackAssignmentQueryError = ErrorType<void>


/**
 * @summary Assignment Details
 */

export function useGetPupilFeedbackAssignment<TData = Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetPupilFeedbackAssignmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPupilFeedbackAssignmentQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Assignment
 */
export const updatePupilFeedbackAssignment = (
    id: MaybeRefOrGetter<string>,
    pupilFeedbackAssignmentRequestInput: MaybeRefOrGetter<PupilFeedbackAssignmentRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
pupilFeedbackAssignmentRequestInput = toValue(pupilFeedbackAssignmentRequestInput);

      return axiosClient<PupilFeedbackAssignment>(
      {url: `/pupil_feedback/assignments/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pupilFeedbackAssignmentRequestInput, signal
    },
      );
    }




export const getUpdatePupilFeedbackAssignmentMutationKey = () => ['updatePupilFeedbackAssignment'] as const;

export const getUpdatePupilFeedbackAssignmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>, TError,UpdatePupilFeedbackAssignmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>, TError,UpdatePupilFeedbackAssignmentMutationVariables, TContext> => {

const mutationKey = getUpdatePupilFeedbackAssignmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>, UpdatePupilFeedbackAssignmentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updatePupilFeedbackAssignment(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePupilFeedbackAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>>
    export type UpdatePupilFeedbackAssignmentMutationBody = PupilFeedbackAssignmentRequestInput
    export type UpdatePupilFeedbackAssignmentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdatePupilFeedbackAssignmentMutationVariables = {id: string;data: PupilFeedbackAssignmentRequestInput}

    /**
 * @summary Update Assignment
 */
export const useUpdatePupilFeedbackAssignment = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>, TError,UpdatePupilFeedbackAssignmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>,
        TError,
        UpdatePupilFeedbackAssignmentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePupilFeedbackAssignmentMutationOptions(options), queryClient);
    }
    /**
 * @summary Finalize Feedback
 */
export const finalizePupilFeedbackFeedback = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PupilFeedbackFeedback>(
      {url: `/pupil_feedback/feedbacks/${id}/finalize`, method: 'PATCH', signal
    },
      );
    }




export const getFinalizePupilFeedbackFeedbackMutationKey = () => ['finalizePupilFeedbackFeedback'] as const;

export const getFinalizePupilFeedbackFeedbackMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>, TError,FinalizePupilFeedbackFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>, TError,FinalizePupilFeedbackFeedbackMutationVariables, TContext> => {

const mutationKey = getFinalizePupilFeedbackFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>, FinalizePupilFeedbackFeedbackMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  finalizePupilFeedbackFeedback(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinalizePupilFeedbackFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>>

    export type FinalizePupilFeedbackFeedbackMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type FinalizePupilFeedbackFeedbackMutationVariables = {id: string}

    /**
 * @summary Finalize Feedback
 */
export const useFinalizePupilFeedbackFeedback = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>, TError,FinalizePupilFeedbackFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>,
        TError,
        FinalizePupilFeedbackFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getFinalizePupilFeedbackFeedbackMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Response
 */
export const deletePupilFeedbackResponse = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/pupil_feedback/responses/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePupilFeedbackResponseMutationKey = () => ['deletePupilFeedbackResponse'] as const;

export const getDeletePupilFeedbackResponseMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>, TError,DeletePupilFeedbackResponseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>, TError,DeletePupilFeedbackResponseMutationVariables, TContext> => {

const mutationKey = getDeletePupilFeedbackResponseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>, DeletePupilFeedbackResponseMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePupilFeedbackResponse(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePupilFeedbackResponseMutationResult = NonNullable<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>>

    export type DeletePupilFeedbackResponseMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeletePupilFeedbackResponseMutationVariables = {id: string}

    /**
 * @summary Delete Response
 */
export const useDeletePupilFeedbackResponse = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>, TError,DeletePupilFeedbackResponseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePupilFeedbackResponse>>,
        TError,
        DeletePupilFeedbackResponseMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePupilFeedbackResponseMutationOptions(options), queryClient);
    }
    /**
 * @summary Get a Pupil Feedback Response
 */
export const getPupilFeedbackResponse = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PupilFeedbackResponse>(
      {url: `/pupil_feedback/responses/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetPupilFeedbackResponseQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'pupil_feedback','responses',id
    ] as const;
    }


export const getGetPupilFeedbackResponseQueryOptions = <TData = Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPupilFeedbackResponseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPupilFeedbackResponse>>> = ({ signal }) => getPupilFeedbackResponse(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError, TData>
}

export type GetPupilFeedbackResponseQueryResult = NonNullable<Awaited<ReturnType<typeof getPupilFeedbackResponse>>>
export type GetPupilFeedbackResponseQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get a Pupil Feedback Response
 */

export function useGetPupilFeedbackResponse<TData = Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPupilFeedbackResponseQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create a Pupil Feedback Feedback
 */
export const createPupilFeedbackFeedback = (
    responseId: MaybeRefOrGetter<string>,
    createPupilFeedbackFeedbackInput: MaybeRefOrGetter<CreatePupilFeedbackFeedbackInput>,
 signal?: AbortSignal
) => {
      responseId = toValue(responseId);
createPupilFeedbackFeedbackInput = toValue(createPupilFeedbackFeedbackInput);

      return axiosClient<PupilFeedbackFeedback>(
      {url: `/pupil_feedback/responses/${responseId}/feedbacks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPupilFeedbackFeedbackInput, signal
    },
      );
    }




export const getCreatePupilFeedbackFeedbackMutationKey = () => ['createPupilFeedbackFeedback'] as const;

export const getCreatePupilFeedbackFeedbackMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>, TError,CreatePupilFeedbackFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>, TError,CreatePupilFeedbackFeedbackMutationVariables, TContext> => {

const mutationKey = getCreatePupilFeedbackFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>, CreatePupilFeedbackFeedbackMutationVariables> = (props) => {
          const {responseId,data} = props ?? {};

          return  createPupilFeedbackFeedback(responseId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePupilFeedbackFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>>
    export type CreatePupilFeedbackFeedbackMutationBody = CreatePupilFeedbackFeedbackInput
    export type CreatePupilFeedbackFeedbackMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreatePupilFeedbackFeedbackMutationVariables = {responseId: string;data: CreatePupilFeedbackFeedbackInput}

    /**
 * @summary Create a Pupil Feedback Feedback
 */
export const useCreatePupilFeedbackFeedback = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>, TError,CreatePupilFeedbackFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPupilFeedbackFeedback>>,
        TError,
        CreatePupilFeedbackFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePupilFeedbackFeedbackMutationOptions(options), queryClient);
    }
